const guaranteeDescription = (days: number, type: "50/50" | "100") => {
    if (type === "50/50") {
        const firstHalf = days / 2;
        const secondHalf = firstHalf + 1;
        return `Relode provides an employment guarantee of ${days} days for hired candidates.  If no replacement candidate can be provided, Relode will refund the client based on days worked: 0-${firstHalf} days = 100% refund, ${secondHalf}-${days} = 50% refund.`;
    }

    return `Relode provides an employment guarantee of ${days} days for hired candidates.  If no replacement candidate can be provided, Relode will refund the client based on days worked: 0-${days} = 100% refund.`;
};
export class EmploymentGuaranteeType {
    readonly id: number;
    readonly label: string;
    readonly description: string;

    constructor(jobTypeId: number, payLabel: string, description: string) {
        this.id = jobTypeId;
        this.label = payLabel;
        this.description = description;
    }

    public static ZeroDays = new EmploymentGuaranteeType(5, "0 days", "");
    public static ThirtyDays50 = new EmploymentGuaranteeType(
        10,
        "30 days 50/50",
        guaranteeDescription(30, "50/50")
    );
    public static ThirtyDays100 = new EmploymentGuaranteeType(
        20,
        "30 days 100%",
        guaranteeDescription(30, "100")
    );
    public static FortyFiveDays100 = new EmploymentGuaranteeType(
        24,
        "45 days 100%",
        guaranteeDescription(45, "100")
    );
    public static FortySixDays50 = new EmploymentGuaranteeType(
        25,
        "46 days 50/50",
        guaranteeDescription(46, "50/50")
    );
    public static SixtyDays50 = new EmploymentGuaranteeType(
        30,
        "60 days 50/50",
        guaranteeDescription(60, "50/50")
    );
    public static SixtyDays100 = new EmploymentGuaranteeType(
        40,
        "60 days 100%",
        guaranteeDescription(60, "100")
    );
    public static SeventyFiveDays100 = new EmploymentGuaranteeType(
        45,
        "75 days 100%",
        guaranteeDescription(75, "100")
    );    
    public static NinetyDays50 = new EmploymentGuaranteeType(
        50,
        "90 days 50/50",
        guaranteeDescription(90, "50/50")
    );
    public static NinetyDays100 = new EmploymentGuaranteeType(
        60,
        "90 days 100%",
        guaranteeDescription(90, "100")
    );
    public static OneHundredTwentyDays50 = new EmploymentGuaranteeType(
        70,
        "120 days 50/50",
        guaranteeDescription(120, "50/50")
    );
    public static OneHundredTwentyDays100 = new EmploymentGuaranteeType(
        80,
        "120 days 100%",
        guaranteeDescription(120, "100")
    );
    public static OneHundredEightyDays50 = new EmploymentGuaranteeType(
        90,
        "180 days 50/50",
        guaranteeDescription(180, "50/50")
    );
    public static OneHundredEightyDays100 = new EmploymentGuaranteeType(
        100,
        "180 days 100%",
        guaranteeDescription(1800, "100")
    );

    public static asArray = () => [
        EmploymentGuaranteeType.ZeroDays,
        EmploymentGuaranteeType.ThirtyDays50,
        EmploymentGuaranteeType.ThirtyDays100,
        EmploymentGuaranteeType.FortyFiveDays100,
        EmploymentGuaranteeType.FortySixDays50,
        EmploymentGuaranteeType.SixtyDays50,
        EmploymentGuaranteeType.SixtyDays100,
        EmploymentGuaranteeType.SeventyFiveDays100,
        EmploymentGuaranteeType.NinetyDays50,
        EmploymentGuaranteeType.NinetyDays100,
        EmploymentGuaranteeType.OneHundredTwentyDays50,
        EmploymentGuaranteeType.OneHundredTwentyDays100,
        EmploymentGuaranteeType.OneHundredEightyDays50,
        EmploymentGuaranteeType.OneHundredEightyDays100,
    ];

    public static fromId = (id: number) =>
        EmploymentGuaranteeType.asArray().find(t => t.id === id);
}
